// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_420c4613","header":"_439a8b3f","column":"_777c1f16","columnShippingReturns":"_4a04b4bd"};